import { CmsService } from './../cms.service';
import { OverlayService } from './../../services/overlay.service';
import { GalleryService } from './../gallery.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-gallery-image-manage',
    templateUrl: './gallery-image-manage.component.html',
    styleUrls: ['./gallery-image-manage.component.scss']
})
export class GalleryImageManageComponent implements OnInit {
    @Input() image;
    @Output() imageMetaUpdated = new EventEmitter();

    repeatForAll = false;

    pages = [];

    buttonClasses = [
        { id: 'btn-yellow', name: 'Yellow' },
        { id: 'btn-white', name: 'White' },
        { id: 'btn-transparent', name: 'Transparent' },
        { id: 'btn-slate', name: 'Slate' },
        { id: 'btn-blue', name: 'Blue' },
    ]

    constructor(
        private galleryService: GalleryService,
        private overlayService: OverlayService,
        private cmsService: CmsService,
    ) { }

    ngOnInit(): void {
        this.getPages();
    }

    getPages() {
        this.cmsService.getAll().subscribe(data => {
            this.pages = data.data;
        })
    }

    saveImageMeta(image) {
        this.galleryService.saveImageMeta(image, this.repeatForAll).subscribe(data => {
            this.imageMetaUpdated.emit({ action: true, repeatForAll: this.repeatForAll });
        });
    }

    toggleValue(v) {
        if (!this.image[v]) {
            this.image[v] = true;
        } else {
            this.image[v] = false;
            this.image.linkPageId = 0;
            this.image.linkText = '';
        }
    }

    toggleRepeatForAll() {
        if (!this.repeatForAll) {
            this.repeatForAll = true;
        } else {
            this.repeatForAll = false;
        }
    }
    close() {

        this.imageMetaUpdated.emit({ action: false, repeatForAll: false });
        this.overlayService.closeAll();
    }
}
